/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClaimStatusViewModel } from './claimStatusViewModel';
import { PagedModelRequest } from './pagedModelRequest';
import { PagedListMetaData } from './pagedListMetaData';

export interface ClaimStatusViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<ClaimStatusViewModel> | null;
  metaData?: PagedListMetaData;
}
